import React from "react";
import { ModalSmall, TextInput, UI_BODY_SM, colors2 } from "oolib";
import { copyToClipboard } from "@/utils/general";

const LINK_INPUT_ID = "shareReport__publicLink";

/**
 * Shown after a public "share for all to view" link is created. Mirrors the
 * KPShareActions / TplActions share pattern: ModalSmall + a read-only link TextInput with
 * an inline Copy button. See SHARED_REPORTS_DESIGN.md.
 */
export const ShareReportModal = ({ url, onClose }) => {
  return (
    <ModalSmall title="Share report" onClose={onClose}>
      <div>
        <UI_BODY_SM style={{ color: colors2.grey60, paddingBottom: "1.2rem" }}>
          Anyone with this link can view this report — a read-only snapshot as of now.
        </UI_BODY_SM>
        <TextInput
          restrictValUpdate={true}
          type="text"
          size="small"
          value={url}
          id={LINK_INPUT_ID}
          actionBtn={{
            onClick: () => copyToClipboard(LINK_INPUT_ID),
            text: "Copy",
          }}
        />
      </div>
    </ModalSmall>
  );
};
